import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "menu.reservations.reservationDetail.title",
    defaultMessage: "Reservation Detail: {roomStayId}",
  },
  roomReservationNotFound: {
    id: "reservationDetail.roomReservationNotFound",
    defaultMessage: "Room reservation not found",
  },
  alertSuccessTitle: {
    id: "reservations.alert.succes",
    defaultMessage: "Exito",
  },
  alertSuccessText: {
    id: "reservations.alert.success.text",
    defaultMessage: "Los datos de la tarjeta se podrán ver durante 2 minutos haciendo click en",
  },
  alertSuccessConsult: {
    id: "reservations.alert.succes.textConsult",
    defaultMessage: "Consultar",
  },
  successTextBack: {
    id: "reservations.alert.succes.textBack",
    defaultMessage: "Volver",
  },
  close: {
    id: "app.close",
    defaultMessage: "Close",
  },
  date: {
    id: "app.date",
    defaultMessage: "date",
  },
  amount: {
    id: "app.amount",
    defaultMessage: "amount",
  },
  inventoryLine: {
    id: "app.inventoryLine",
    defaultMessage: "inventoryLine",
  },
  appliedOffers: {
    id: "reservations.combinedDiscounts.appliedOffers",
    defaultMessage: "Applied offers",
  },
  appliedRate: {
    id: "reservations.combinedDiscounts.appliedRate",
    defaultMessage: "Applied Rate",
  },
});

export const alertMessages = defineMessages({
  successTitle: {
    id: "reservations.alert.succes",
    defaultMessage: "Exito",
  },
  successText: {
    id: "reservations.alert.success.text",
    defaultMessage: "Los datos de la tarjeta se podrán ver durante 2 minutos haciendo click en",
  },
  successConsult: {
    id: "reservations.alert.succes.textConsult",
    defaultMessage: "Consultar",
  },
  successTextBack: {
    id: "reservations.alert.succes.textBack",
    defaultMessage: "Volver",
  },
  errorTitle: {
    id: "reservations.alert.error",
    defaultMessage: "Error",
  },
  warningTitle: {
    id: "reservations.alert.warning",
    defaultMessage: "Advertencia",
  },
  warningText: {
    id: "reservations.alert.warning.text",
    defaultMessage: "Hemos tenido un problemas, intentalo mas tarde.",
  },
  credentialsModalUsername: {
    id: "reservations.credentials.modal.username",
    defaultMessage: "Username",
  },
  credentialsModalPassword: {
    id: "reservations.credentials.modal.password",
    defaultMessage: "Password",
  },
  credentialsModalInvalidUser: {
    id: "reservations.credentials.modal.invalidUser",
    defaultMessage: "Invalid user",
  },
});

export const optionsMessages = defineMessages({
  loadAmount: {
    id: "reservationDetail.payment.options.loadAmount",
    defaultMessage: "Load amount",
  },
  loadDepositAmount: {
    id: "reservationDetail.payment.options.loadDepositAmount",
    defaultMessage: "Load deposit amount",
  },
  loadPendingAmount: {
    id: "reservationDetail.payment.options.loadPendingAmount",
    defaultMessage: "Load pending amount",
  },
  loadTotalAmount: {
    id: "reservationDetail.payment.options.loadTotalAmount",
    defaultMessage: "Load total amount",
  },
  refund: {
    id: "reservationDetail.payment.options.refund",
    defaultMessage: "Refund",
  },
});

export const toastMessages = defineMessages({
  genericSuccess: {
    id: "reservationDetail.success",
    defaultMessage: "Successful operation",
  },
  genericError: {
    id: "reservationDetail.errors.someErrorOccurred",
    defaultMessage: "Some error occurred",
  },
  genericWarning: {
    id: "reservationDetail.warnings.genericWarning",
    defaultMessage: "Important",
  },
  getPaymentConfigsError: {
    id: "reservationDetail.errors.getPaymentConfigsError",
    defaultMessage: "Error on getting payments config",
  },
  getReservationAndPropertyDataError: {
    id: "reservationDetail.errors.getReservationAndPropertyDataError",
    defaultMessage: "Error on getting reservation and property data",
  },
  getUserProfileError: {
    id: "reservationDetail.errors.getUserProfileError",
    defaultMessage: "Error on getting user profile",
  },
  getTransactionsError: {
    id: "reservationDetail.errors.getTransactionsError",
    defaultMessage: "Error on getting transactions",
  },
  deferredPaymentNotUpdatedYet: {
    id: "reservationDetail.warnings.deferredPaymentNotUpdatedYet",
    defaultMessage: "This is a deferred reservation. payment is not updated yet",
  }
});

export const alertPaymentMessages = defineMessages({
  paymentChargeSuccess: {
    id: "reservationDetail.payment.paymentChargeSuccess",
    defaultMessage: "Charge done correctly",
  },
  paymentRefundSuccess: {
    id: "reservationDetail.payment.paymentRefundSuccess",
    defaultMessage: "Refund done correctly",
  },
  paymentChargeError: {
    id: "reservationDetail.payment.paymentChargeError",
    defaultMessage: "Error on payment charge",
  },
  paymentRefundError: {
    id: "reservationDetail.payment.paymentRefundError",
    defaultMessage: "Error on payment refund",
  },
});
